import { createAction, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateUserProps, LoadUserOrgProps, LoadUserProps, ReduxUsersAddEditSlice, UpdateUserProps, UserFormState } from '../types';
import { ISelectItem, ReduxSliceState } from '../../../shared/types';
import { OrganizationItem, UserRole } from '../../../api/types';
import { getAvailableUserTypes, withPayloadType } from '../../../shared/utils';
import { ReduxRootState } from '../../../shared/redux/store';

const initialState: ReduxUsersAddEditSlice = {
    state: 'BUSY',
    user: undefined,
    userOrg: undefined,
    roles: [],
};

export const loadUser = createAction('users/add-edit/loadUser', withPayloadType<LoadUserProps>());
export const loadUserOrg = createAction('users/add-edit/loadUserOrg', withPayloadType<LoadUserOrgProps>());
export const createUser = createAction('users/add-edit/createUser', withPayloadType<CreateUserProps>());
export const updateUser = createAction('users/add-edit/updateUser', withPayloadType<UpdateUserProps>());
export const loadUserRoles = createAction('users/add-edit/loadUserRoles');

const usersAddEditSlice = createSlice({
    name: 'users/add-edit',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setUser: (state, action: PayloadAction<UserFormState | undefined>) => {
            state.user = action.payload;
        },
        setUserOrg: (state, action: PayloadAction<OrganizationItem | undefined>) => {
            state.userOrg = action.payload;
        },
        setRoles: (state, action: PayloadAction<UserRole[]>) => {
            state.roles = action.payload;
        },
    }
});

export default usersAddEditSlice;
const selectSelf = (state: ReduxRootState) => state.usersAddEdit;
export const selectUsersAddEditState = createSelector(selectSelf, self => self.state);
export const selectUsersAddEditIsBusy = createSelector(selectUsersAddEditState, state => state === 'BUSY');
export const selectUsersAddEditUser = createSelector(selectSelf, self => self.user);
export const selectUsersAddEditUserEmail = createSelector(selectUsersAddEditUser, user => user?.email);
export const selectUsersAddEditUserRole = createSelector(selectUsersAddEditUser, user => user?.roleName);
export const selectUsersAddEditUserOrg = createSelector(selectSelf, self => self.userOrg);
export const selectUsersAddEditRoles = createSelector(selectSelf, self => self.roles);
export const selectUsersAddEditRolesList = createSelector(selectUsersAddEditRoles, roles => roles.map<ISelectItem>(role => ({
    label: role.name,
    value: role.name,
})));

export const selectUsersAddEditRolesListAvailable = (currentUserRole: string) => createSelector(
    selectUsersAddEditRolesList,
    roles => getAvailableUserTypes(currentUserRole, roles)
);